import { motion } from "framer-motion";
import { useMenu } from "@/menu/MenuApp";

const AllergensPage = () => {
  const { data, lang, t } = useMenu();

  return (
    <div data-testid="menu-allergens-page" className="mx-auto max-w-3xl px-5 py-12">
      <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#C19D60]">Reg. UE 1169/2011</p>
      <h1 className="font-display mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">{t("allergensTitle")}</h1>
      <p className="mt-5 max-w-xl text-sm font-light leading-relaxed text-[#A3A3A3]">{t("allergensSub")}</p>

      <div className="mt-12 space-y-px overflow-hidden rounded-lg border border-white/5">
        {data.allergens.map((a, i) => (
          <motion.div
            key={a.code}
            data-testid={`allergen-${a.code}`}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-20px" }}
            transition={{ duration: 0.5, delay: 0.03 * i }}
            className="flex items-start gap-5 bg-[#101012] p-5"
          >
            <span className="font-display mt-0.5 w-9 shrink-0 text-2xl font-light italic text-[#C19D60]/70">{String(a.code).padStart(2, "0")}</span>
            <div>
              <h3 className="font-display text-xl font-medium">{lang === "en" ? a.en : a[lang] || a.it}</h3>
              <p className="mt-1 text-[13px] font-light leading-relaxed text-[#A3A3A3]">{lang === "en" ? a.desc_en : a[`desc_${lang}`] || a.desc_it}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AllergensPage;
